export const ActionTypes = {
  LOADING: "DELETE_ACCOUNT_LOADING",
  ERROR: "DELETE_ACCOUNT_ERROR",
  SUCCESS: "DELETE_ACCOUNT_SUCCESS",
};
